import { API_ENDPOINT } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const PRODUCT_HISTORY_ENDPONT = `${API_ENDPOINT}/tracking/product`;

const historyApi = {
   getProductHistory: (params) => {
      return axiosClient.get(PRODUCT_HISTORY_ENDPONT, { params });
   },
};

export default historyApi;
